
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { initializeErrorLogging } from './utils/errorLogger.ts'

// Initialize error logging
initializeErrorLogging();

// Wait for DOM to be fully loaded before initializing the app
const initApp = () => {
  const rootElement = document.getElementById('root');

  if (rootElement) {
    console.log('DOM ready, initializing app...');
    try {
      createRoot(rootElement).render(
        <ErrorBoundary>
          <React.StrictMode>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </React.StrictMode>
        </ErrorBoundary>
      );
      console.log('App rendered successfully');
    } catch (error) {
      console.error('Error rendering application:', error);
      // Display error message in the UI as a fallback
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center;">
          <h2>Application Error</h2>
          <p>Sorry, something went wrong while loading the application.</p>
          <p>Please refresh the page or try again later.</p>
          <button onclick="window.location.reload()" style="padding: 8px 16px; margin-top: 20px;">
            Refresh Page
          </button>
        </div>
      `;
    }
  } else {
    console.error("Root element not found");
  }
};

// Ensure the DOM is ready before initializing
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  // Set a small timeout to ensure all scripts are loaded
  setTimeout(initApp, 50); // Increased timeout for better reliability
}

// Add unhandled error listeners for debugging
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});
